import React from 'react';
import { z } from 'zod';
import { Checkbox } from '@/components/ui/checkbox';
import { useFormContext } from 'react-hook-form';
import { QuestionData } from '../types';

interface CheckboxFieldProps {
  question: QuestionData;
  disabled?: boolean;
}

const CheckboxFieldComponent: React.FC<CheckboxFieldProps> = ({
  question,
  disabled,
}) => {
  const { register } = useFormContext();

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        {...register(question.slug)}
        id={question.id}
        disabled={disabled}
      />
      <label
        htmlFor={question.id}
        className="text-sm text-gray-700 cursor-pointer"
      >
        {question.meta?.checkboxLabel || 'Check this option'}
      </label>
    </div>
  );
};

const createCheckboxSchema = (question: QuestionData): z.ZodTypeAny => {
  const schema = z.boolean();
  if (question.required) {
    return schema.refine(val => val === true, {
      message: 'This field is required',
    });
  }
  return schema.optional();
};

const getDefaultValue = (): boolean => false;

export const CheckboxField = {
  component: CheckboxFieldComponent,
  createSchema: createCheckboxSchema,
  getDefaultValue: () => getDefaultValue(),
};
